__turbopack_context__.v({
  "dot": "Metro-module-sass-module__QpCiMG__dot",
  "dots": "Metro-module-sass-module__QpCiMG__dots",
  "metro": "Metro-module-sass-module__QpCiMG__metro",
  "metro-link": "Metro-module-sass-module__QpCiMG__metro-link",
});
